
import { PackageData } from "@/pages/CreatePackage";
import { TemplateStyle } from "../types";
import { companyName } from "../constants";
import { generateQrCode } from "../helpers";
import { renderCommonSection } from "../commonSections";

const renderSection = (sectionId: string, packageData: PackageData): string => {
  const common = renderCommonSection(sectionId, packageData);
  if (common !== null) return common;

  switch (sectionId) {
    case 'client': {
        const clientCompanyLogoHtml = packageData.companyLogoUrl ? `<img src="${packageData.companyLogoUrl}" alt="شعار شركة العميل" style="max-height: 40px; margin-bottom: 10px; border-radius: 4px; background: white; padding: 4px;" />` : '';
        const companyNameHtml = packageData.companyName ? `<div class="item"><strong>الشركة:</strong> ${packageData.companyName}</div>` : '';
        return `<div class="section">
                    <h3>معلومات العميل</h3>
                    ${clientCompanyLogoHtml}
                    ${companyNameHtml}
                    <div class="item"><strong>جهة الاتصال:</strong> ${packageData.clientName}</div>
                    <div class="item"><strong>البريد الإلكتروني:</strong> ${packageData.clientEmail}</div>
                </div>`;
    }
    case 'hotels':
      if (packageData.hotels.length === 0) return '';
      return `<div class="section"><h3>الإقامة الفندقية</h3>${packageData.hotels.map(hotel => `<div class="item"><strong>${hotel.name}</strong> - ${hotel.nights} ليالي</div>`).join('')}</div>`;
    case 'flights':
      if (packageData.flights.length === 0) return '';
      return `<div class="section"><h3>رحلات الطيران</h3>${packageData.flights.map(flight => `<div class="item"><strong>${flight.airline}</strong>: ${flight.from} - ${flight.to}</div>`).join('')}</div>`;
    case 'tours':
      if (packageData.tours.length === 0) return '';
      return `<div class="section"><h3>الجولات</h3>${packageData.tours.map(tour => `<div class="item"><strong>${tour.name}</strong><br>${tour.description}</div>`).join('')}</div>`;
    case 'price':
      return `<div class="price-box"><div class="total">$${packageData.totalPrice}</div></div>`;
    default:
      return '';
  }
};

export const getTemplate4HTML = async (packageData: PackageData, settings: TemplateStyle): Promise<string> => {
  const columnsHtml = settings.columns.map(column => {
    const sectionsHtml = column.sections.map(section => renderSection(section.id, packageData)).join('');
    return `<div class="pdf-column">${sectionsHtml}</div>`;
  }).join('');

  const qrCodeData = await generateQrCode(`Package: ${packageData.packageName}\nClient: ${packageData.clientName}\nPrice: $${packageData.totalPrice}`);
  
  const logoHtml = settings.media?.logo ? `<img src="${settings.media.logo}" alt="Company Logo" style="max-height: 80px; margin: 0 auto 20px auto; display: block; filter: brightness(0) invert(1);" />` : '';
  const backgroundStyle = settings.media?.background ? `background: url('${settings.media.background}') center center / cover no-repeat;` : `background: linear-gradient(145deg, #1e293b, #0f172a);`;

  return `
    <!DOCTYPE html>
    <html dir="rtl" lang="ar">
    <head>
      <meta charset="UTF-8">
      <title>عرض سياحي - ${packageData.packageName}</title>
      <link href="https://fonts.googleapis.com/css2?family=Almarai:wght@400;700&display=swap" rel="stylesheet">
      <style>
        body { font-family: 'Almarai', sans-serif; background-color: #0b1120; color: ${settings.colors.text}; }
        .container { max-width: 800px; margin: 20px auto; border: 1px solid #334155; border-radius: 10px; box-shadow: 0 0 40px rgba(8, 145, 178, 0.2); ${backgroundStyle} }
        .header { padding: 40px; text-align: center; border-bottom: 1px solid ${settings.colors.primary}; background-color: rgba(30, 41, 59, 0.5); }
        .header h1 { font-size: 36px; margin: 0; color: #fff; font-weight: 700; }
        .header p { font-size: 18px; color: #94a3b8; margin: 10px 0 0; }
        .content { padding: 30px; }
        .pdf-row { display: flex; flex-direction: row; gap: 20px; }
        .pdf-column { flex: 1; min-width: 0; }
        .section { margin-bottom: 25px; background-color: ${settings.colors.background}; padding: 20px; border-radius: 8px; }
        .section h3 { font-size: 22px; color: ${settings.colors.primary}; margin-bottom: 15px; }
        .item { padding-bottom: 10px; margin-bottom: 10px; border-bottom: 1px solid #334155; }
        .price-box { padding: 25px; background: ${settings.colors.primary}; color: #fff; text-align: center; border-radius: 8px; margin-top: 30px; }
        .price-box .total { font-size: 36px; font-weight: 700; }
        .footer { text-align: center; color: #64748b; padding: 20px; font-size: 12px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          ${logoHtml}
          <h1>${packageData.packageName || 'عرض إبداع رقمي'}</h1>
          <p>${packageData.destination} - ${packageData.duration}</p>
        </div>
        <div class="content">
          <div class="pdf-row">
            ${columnsHtml}
          </div>
          <div class="footer">
            <img src="${qrCodeData}" alt="QR Code" style="width:80px;height:80px;margin:10px auto; border-radius: 5px;" />
            عرض مقدم من ${companyName}
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};
